import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Checkbox, Button } from '@mui/material';
import * as XLSX from 'xlsx';
import Util from "../../Service/util";
import Service from "../../Service/http";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ReactTable from 'react-table-6';
import "react-table-6/react-table.css";
import withFixedColumns from 'react-table-hoc-fixed-columns';
import 'react-table-hoc-fixed-columns/lib/styles.css'
import { VscCloudDownload } from "react-icons/vsc"
import { CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Switch } from "@mui/material";
import { Tooltip, IconButton, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";


import { FadeLoader } from "react-spinners";
const ReactTableFixedColumns = withFixedColumns(ReactTable);
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function ContestReports() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const batchess = queryParams.get('batches');
  let contestData = queryParams.get("contest");

  const service = new Service();
  const util = new Util();
  let [loggedIn, SetLoggedIn] = useState(false);
  let [isAdmin, SetIsAdmin] = useState(false);
  let [role, SetRole] = useState("student");
  let [batches, SetBatches] = useState(['All Batches']);
  let [filteredBatches, setfilteredBatches] = useState([])
  let [filteredContests, setfilteredContests] = useState([]);
  let [contests, SetContests] = useState([]);
  let [searchContests, SetSearchContests] = useState();
  let [data, SetData] = useState([]);
  let [Page, SetPage] = useState(1)
  let [FinalPage, SetFinalPage] = useState(-1);
  let [PageSize, SetPageSize] = useState(50)
  let [PageSizeOption, SetPageSizeOption] = useState([5, 10, 20, 25, 50, 100])
  let [QueryButton, SetQueryButton] = useState(false);
  let [QueryText, SetQueryText] = useState("Search Participation");
  let [loading, SetLoading] = useState(false);
  let [dataLoading, SetDataLoading] = useState(false);
  let [callOnSubmit, setOnCallOnSubmit] = useState(null);
  let [problemsData, SetProblemsData] = useState([]);
  let [isDetailedView, setIsDetailedView] = useState(false);
  const [isDetailedViewAllowed, setIsDetailedViewAllowed] = useState(false);

  function BuildCSV(isDetailedView) {
    const download_data = data;
    if (download_data.length === 0) {
      return;
    }
  
    const date = new Date();
    const date_options = {
      weekday: undefined,
      year: "numeric",
      month: "long",
      day: "numeric",
    };
  
    let batchesList = "[" + filteredBatches.join(",") + "]";
    let contestList =
      "[" + filteredContests.map((contest) => contest.contestName).join(",") + "]";
  
    const download_title = `${batchesList}-${contestList} ${date.toLocaleDateString(
      undefined,
      date_options
    )} ${date.toLocaleTimeString("en-US")}`;
    const fileName = download_title.split(" ").join("-") + ".xlsx";
  
    // Prepare headers based on isDetailedView
    const headers = [
      "No",
      "Name",
      "Roll No",
      "Batch",
      ...filteredContests.map((contest) => contest.contestName),
      ...(isDetailedView
        ? Object.entries(problemsData).flatMap(([contestName, problems]) =>
            problems.map((problem) => `Contest: ${contestName} - ${problem}`)
          )
        : []),
    ];
  
    // Prepare data rows
    const rows = download_data.map((row) => {
      const rowData = [
        row.no,
        row.name || "NA",
        row.rollNumber || "NA",
        row.batches ? row.batches.join(" ") : "NA",
      ];
  
      filteredContests.forEach((contest) => {
        const contestName = contest.contestName;
       
          if (row.contests[contestName].contestSolvedCount>0) {
            let cellData = row.contests[contestName].contestSolvedCount;
            rowData.push(cellData);
          } else {
            rowData.push("Not Participated");
          }
       
      });
  
      if (isDetailedView) {
        // Add detailed columns for problems
        Object.entries(problemsData).forEach(([contestName, problems]) => {
          problems.forEach((problem) => {
            const contestData = row.contests?.[contestName] || {};
            const solvedProblems = contestData.solved || [];
            const upsolvedProblems = contestData.upSolved || [];
            if (solvedProblems.includes(problem)) {
              rowData.push("Solved");
            } else if (upsolvedProblems.includes(problem)) {
              rowData.push("Upsolved");
            } else {
              rowData.push("Not Solved");
            }
          });
        });
      }
  
      return rowData;
    });
  
    // Combine headers and rows into one data array
    const worksheet_data = [headers, ...rows];
  
    // Create a worksheet and a workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheet_data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
  
    // Generate XLSX file and download it
    XLSX.writeFile(workbook, fileName);
  }
  

  function debounce(func, timeout = 1000) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }
  const processChange = debounce((text) => SetSearchContests(text));

  function PaginationUpdate(){
    let Datalength = data?.length;
    if(Datalength === 0 || Datalength === null){
      SetPageSizeOption([5, 10, 15, 25, 50])
    }
    else{
    let pageOptions = []
    let defaultOptions = [5,10,20,25,50,100];
    defaultOptions.forEach(item => {
      const cur = Number(item);
      if(cur <= Datalength){
          pageOptions.push(cur)
      }
    })
    let num = 200;
    while(Number(num) <= Datalength){
      pageOptions.push(Number(num));
      num += 100;
    }
    if(pageOptions[pageOptions.length - 1] != Datalength){
      pageOptions.push(Number(Datalength));
    }
    SetPageSizeOption(pageOptions);
  }
  }

  function cellData(e, contest){

    let showText = "Participated"

    if(e.original?.contests[contest?.contestName].participated ){
      showText = e.original?.contests[contest?.contestName].contestSolvedCount
    }

   return  showText;

  }

  function PopulatedFill(){
    let Datalength = data?.length;
    if(Page === FinalPage){
      let cur_size = PageSize;
      if(cur_size === 0){
        cur_size = 10;
      }
      const res = Datalength % cur_size;
      if(!isNaN(res) && res !== 0){
        SetPageSize(res);
      }
    }
  }

  useEffect(()=>{
    handleSubmit();
  },[callOnSubmit])


  useEffect(() => {

    if (contestData) {
      try {

        let tempContestData = JSON.parse(contestData);

        // Filter out unwanted data
        const filteredData = tempContestData.filter(contest => 
          contest.contestName !== "GRAND TOTAL" &&
          contest.contestName !== "PARTICIPATION %"
        );

        // Set the filtered data to state
        setfilteredBatches([batchess])
        SetContests(filteredData)
        setfilteredContests(filteredData);
        setOnCallOnSubmit(true);
      
      } catch (error) {
        console.error('Error parsing data from URL:', error);
      }
    }

 

    let isLogin = util.loggedIn();
    let admin = util.isAdmin();
    SetRole(util.getRole());
    SetIsAdmin(admin);
    SetLoggedIn(isLogin);
    if (!isLogin && window.location.pathname !== "/login") {
      window.location.replace("/login");
    }
    if (isLogin && admin) {
      service.get("api/batches").then(json => {
        let batches = ['All Batches'];
        json.batches.map((batch) => {batches.push(batch)});
        SetBatches(batches);
      })
      .catch((err) =>{
        console.log(err);
      })
    
    }
  }, []);

  const handleSubmit = () => {
    const searchParams = {
        batches: filteredBatches,
        contests: filteredContests,
    }

    if (searchParams && searchParams?.batches?.length > 0 && searchParams?.contests?.length > 0) {
        SetDataLoading(true);

        const endpoint = `api/contests/participation${isDetailedView ? '?detailedView=true' : ''}`;

        service
            .post(endpoint, searchParams)
            .then((json) => {
                let contests = [];
                let j = 1;
                for (let item in json.data) {
                    contests.push({
                        no: j++,
                        name: json.data[item].name,
                        userId: json.data[item].user_id,
                        rollNumber: json.data[item].roll_number,
                        contests: json.data[item]?.contests,
                        batches: json.data[item].batches,
                    });
                }
                let detailedViewAllowed = true;
                const contestProblemMap = json.contestDetails.reduce((map, contest) => {
                    map[contest.contestName] = contest.problems;
                    if (contest.startTime < 1739836800) {        // if any contest is older than 18th Feb 2025, disable detailed view
                      detailedViewAllowed = false; 
                    }
                    return map;
                }, {});
                setIsDetailedViewAllowed(detailedViewAllowed);   // set detailed view allowed based on contest start time

                if(!detailedViewAllowed && isDetailedView) {     // if detailed view is enabled but not allowed, disable it
                    setIsDetailedView(false);
                }
                SetPageSize(Math.max(10, Math.min(50, contests?.length)));
                SetData(contests);
                SetQueryButton(false);
                SetDataLoading(false);
                SetQueryText("Search Participation");
                SetProblemsData(contestProblemMap);
            })
            .catch((error) => {
                SetDataLoading(false);
                console.log(error);
            });
      } else {
          SetData([]);
      }
  }


  const processColumns = () => {
    const baseColumns = [
      {
        Header: "USER DETAILS",
        fixed: "left",
        columns: [
          {
            Header: "No",
            accessor: "no",
            width: 50,
            getProps: (state, rowInfo, column) => ({
              style: { background: rowInfo ? "#0F9ADC" : "" },
            }),
          },
          {
            Header: "Name",
            accessor: "name",
            width: 250,
            Cell: (e) => (
              <a
                style={{ color: "white", textDecoration: "underline" }}
                target="_blank"
                href={"/coding/profile/" + e.original.userId}
              >
                {e.value}
              </a>
            ),
            getProps: (state, rowInfo, column) => ({
              style: { background: rowInfo ? "#0F9ADC" : "" },
            }),
          },
          {
            Header: "Roll No",
            accessor: "rollNumber",
            width: 150,
            Cell: (e) => <a style={{ color: "white" }}>{e.value || "NA"}</a>,
            getProps: (state, rowInfo, column) => ({
              style: { background: rowInfo ? "#0F9ADC" : "" },
            }),
          },
        ],
      },
    ];
    const contestColumns = filteredContests.map((contest) => ({
      Header: contest?.contestName,
      accessor: `contests.${contest?.contestName}.participated`,
      sortable: true,
      width: 150,
      Cell: (e) =>
        e ? (
          <a
            style={{ color: "white" }}
            target="_blank"
            href={e?.contestName}
          >
            {e?.original?.contests?.[contest?.contestName]?.participated
              ? cellData(e, contest)
              : "Not Participated"}
          </a>
        ) : (
          "Not Participated"
        ),
      getProps: (state, rowInfo, column) => ({
        style: {
          background:
            rowInfo &&
            rowInfo?.original?.contests?.[contest?.contestName]?.participated
              ? "rgba(65, 220, 51, 0.86)" // Green for Participated
              : "rgba(249, 0, 50, 0.7)", // Red for not participated
        },
        
      }),
    }));

    if (!isDetailedView) {
      // Return basic columns if detailed view is off
      return [...baseColumns, { Header: "CONTESTS", columns: contestColumns }];
    }

    // Add detailed problem details columns
    const problemDetailsColumns = Object.entries(problemsData)
  .filter(([contestName]) => 
    filteredContests.some((contest) => contest.contestName === contestName)
  )
  .map(([contestName, problems]) => ({
    Header: `Contest: ${contestName}`,
    columns: problems.map((problem) => ({
      Header: problem,
      accessor: `contests[${contestName}]`,
      sortable: true,
      width: 150,
      Cell: (e) => {
        const contestData = e.original?.contests?.[contestName] || {};
        const solvedProblems = contestData.solved || [];
        const upsolvedProblems = contestData.upSolved || [];
        const isSolved = solvedProblems.includes(problem);
        const isupSolved = upsolvedProblems.includes(problem);

        return isSolved
          ? "Solved"
          : isupSolved
          ? "Upsolved"
          : "Not Solved";
      },
      getProps: (state, rowInfo, column) => {
        if (rowInfo) {
          const contestData = rowInfo.original?.contests?.[contestName] || {};
          const solvedProblems = contestData.solved || [];
          const upsolvedProblems = contestData.upSolved || [];
          const isSolved = solvedProblems.includes(problem);
          const isupSolved = upsolvedProblems.includes(problem);

          return {
            style: {
              backgroundColor: isSolved
                ?  "rgba(65, 220, 51, 0.86)" // Solved
                : isupSolved
                ?  "rgba(0, 83, 249, 0.7)" // Upsolved
                : "rgba(249, 0, 50, 0.7)", // Not Solved
              color: "white",
              textAlign: "center",
            },
          };
        }
        return {};
      },
    })),
  }));


    return [
      ...baseColumns,
      { Header: "CONTESTS", columns: contestColumns },
      ...problemDetailsColumns,
    ];
  };
  
  useEffect(() => {
    PaginationUpdate();
  }, [data])

  useEffect(() => {
    PopulatedFill();
  }, [Page, FinalPage])

  useEffect(() => {
    if (searchContests && searchContests.length > 0) {
      SetLoading(true);
      service
      .get("api/contests/" + searchContests)
      .then((json) => {
        SetContests(json);
        SetLoading(false);
      }).catch((error) => {
        console.log(error);
        SetLoading(false);
      })
    }
    else{
      SetContests([]);
    }
  }, [searchContests]);

  useEffect(() => {
      if(filteredBatches.length > 0 && filteredContests.length > 0){
        SetQueryText("Update Participation");
        SetQueryButton(true);
      }
      else{
        SetQueryText("Search Participation");
        SetQueryButton(false);
      }
  }, [filteredContests, filteredBatches]);

  useEffect(() => {
      handleSubmit();
  }, [isDetailedView]);

  const getTooltipText = () => {
    if(contests.length === 0){
      return "No contests available to show";
    }
    if (!isDetailedViewAllowed) {
      return "Detailed view is not available for contests older than 18th Feb 2025";
    }
    return ""; 
  };

  return (
  <div className=' text-center text-dark h2 '  style={{minHeight:"100vh",
  fontWeight:"revert-layer"


   }}>
    <p className="mt-4">Contest Participation</p>

    <div className="p-0 m-0 h5 text-primary " style={{textDecoration: 'none',  fontWeight:"600",
   textShadow:"0px 0px #C0C0C0"
}}>
  <VscCloudDownload
      data-bs-toggle="tooltip"
      title="Download Contest Participation Data"
      data-bs-placement="bottom"
      size={40}
      style={{
        cursor: "pointer",
        position: "absolute",
        top : 60,
        right: 10,
        zIndex:100
      }}
      onClick={() => BuildCSV(isDetailedView)}
    />
  
  </div>
  
  <div style={{verticalAlign : "middle"}}>
  <Autocomplete
  multiple
  disablePortal
  disableCloseOnSelect
  id="checkboxes-tags-demo"
  renderOption={(props, option, { selected }) => (
    <li {...props}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        style={{ marginRight: 8  }}
        checked={selected}
      />
      {option}
    </li>
  )}
  options={(filteredBatches.includes('All Batches'))? ['All Batches'] : batches}
  sx={{ width: 300 , display: 'inline-block', marginRight: 6, verticalAlign : "middle"}}
  onChange={(event, newValue) => {setfilteredBatches(newValue); }}
  renderInput={(params) => <TextField {...params} label="Select Batches" />}
/>
    

    <Autocomplete
      multiple
      disableCloseOnSelect
      isOptionEqualToValue = {(option, value) => {
        for(let i = 0; i < filteredContests.length; i++){
          if(filteredContests[i].contestName === option.contestName)
            return true;
        }
        return false;
      }}
      loading={loading}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {(option.siteName === "CODEFORCES") ?  option.contestName + " (" + option.contestId + ")"  : option.contestName}
        </li>
      )}
      options={contests}
      getOptionLabel={(option) => (option.siteName === "CODEFORCES") ?  option.contestName + " (" + option.contestId + ")"  : option.contestName}
      groupBy={(option) => option.siteName}
      sx={{ width: 600, display: 'inline-block' }}
      onChange={(event, newValue) => {setfilteredContests(newValue);}}
      renderInput={(params) => <TextField {...params} onChange = {(e) => {
        processChange(e.target.value);
      }} 
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <React.Fragment>
            {loading ? <CircularProgress color="inherit" size={20} /> : null}
            {params.InputProps.endAdornment}
          </React.Fragment>
        ),
      }}
      sx={{ width: 600, display: 'inline-block', verticalAlign : "middle" }}
      label="Select Contests" />}
    />
    <Button onClick={handleSubmit} 
      disabled = {!QueryButton}
    variant="contained" color="primary" style={{
      marginLeft: '36px',  
      height: '50px',  verticalAlign : "middle"
     }}>
        {QueryText}
      </Button> 
    </div>
     {dataLoading ? <div style={{ marginTop: "10vh", marginRight:"10vh",textAlign:"center"}}><FadeLoader  margin={5} color="green" /></div>:null}

     <div style={{ marginBottom: "10px", alignItems: "center", gap: "8px" }}>
        <Switch
          checked={isDetailedView}
          onChange={(e) => setIsDetailedView(e.target.checked)}
          color="primary"
          disabled={!isDetailedViewAllowed}     // disable switch if detailed view is not allowed
        />
        <label>{isDetailedView ? "Detailed View" : "Default View"}</label>
        {contests.length > 0 && !isDetailedViewAllowed && getTooltipText() && (
          <Tooltip
            title={
              <Typography sx={{ fontSize: "14px", lineHeight: "1.5" }}>
                {getTooltipText()}
              </Typography>
            }
            arrow
          >
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {isDetailedViewAllowed && isDetailedView && (
          <Typography sx={{ fontSize: "15px", color: "gray" }}>
            Note: For Codechef, it may take upto 48 hrs to reflect the exact solved/upsolved data for all users.
          </Typography>
        )}
      </div>

    {!dataLoading && data.length > 0 && 
       <ReactTableFixedColumns
       data={data}
       style={{ textAlign: "center", fontWeight: "bolder",fontSize:"16px",height: 'auto', marginTop: '20px'}}
        pageSize = {PageSize}
        pageSizeOptions = {PageSizeOption}
        minRows = {5}
        loadingText = {'Loading Participation Data...'}
        onPageSizeChange = {(pageSize, pageIndex) =>{
          SetPage(pageIndex)
          SetPageSize(pageSize)
        }}
        onPageChange = {(num) => {
          SetPage(num);
        }}
        renderTotalPagesCount = {(num) => {
          if(!isFinite(num) || isNaN(num)){
            num = 1;
          }
          SetFinalPage(num);
          if(num === 0){
            return 1;
          }
          return num;
        }}
        columns= {processColumns()}
       />
    }

    </div>

  );
}

export default ContestReports;

